import { MenuItem } from '../models/menu/menu.model';

export const vivoMenu: MenuItem[] = [];
